var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferToZoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110.483,
    height: 110
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7556 81.5617L73.167 89.6292L76.7872 93.5557L92.4037 78.8797L76.7872 64.2037L73.167 68.1301L81.7556 76.1977H34.5768C28.4087 76.1977 23.3872 71.1233 23.3872 64.8903L23.3979 49.7744H18.0791V64.8903C18.0791 74.0842 25.4787 81.5617 34.5768 81.5617H81.7556Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7272 27.4383L37.3158 19.3708L33.6957 15.4443L18.0791 30.1203L33.6957 44.7963L37.3158 40.8699L28.7272 32.8024H75.8954C82.0635 32.8024 87.085 37.8767 87.085 44.1097V59.2256H92.4037V44.1097C92.4037 34.9158 85.0042 27.4383 75.906 27.4383H28.7272Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferToZoneIcon);
export default __webpack_public_path__ + "static/media/transfer-to-zone-icon.64ac91756b2fee32ee06caf8eb45adc1.svg";
export { ForwardRef as ReactComponent };